import React from "react";
import {
  Card,
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { invalid } from "../../assets/imgs/images";

const InvalidPage = () => {
  return (
    <Card
      className="mx-auto mt-5"
      style={{ width: 350, height: 250, boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.3)' }}
      bodyStyle={{ height: '100%' }}
    >
      <div className="d-flex flex-column align-items-center justify-content-center mx-auto h-100">
       <ExclamationCircleOutlined style={{ color: 'red', fontSize: '36px' }} />
        <h5 className="mt-5">Invalid Table Id</h5>
      </div>
    </Card>
  );
};

export default InvalidPage;
